import { useNavigate } from 'react-router-dom';
import {
  VStack,
  Button,
  AbsoluteCenter,
  Image,
} from '@chakra-ui/react';
import { EmptyState } from '@/components/ui/empty-state';
import { FormattedMessage, useIntl } from 'react-intl';
import notFoundImage from '@/assets/illustrations/not-found.png';

export function NotFound() {
  const navigate = useNavigate();
  const intl = useIntl();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <VStack align="center" justify="center" minH="60vh" px={{ base: 4, md: 0 }}>
      <AbsoluteCenter>
        <EmptyState
          maxW={{ base: 'full', md: 'xl' }}
          icon={
            <Image
              src={notFoundImage}
              alt={intl.formatMessage({ id: '6529734f-8688-46df-be3f-9b0177cc71f4', defaultMessage: 'Page not found' })}
              maxW="sm"
              h="auto"
            />
          }
          title={
            <FormattedMessage
              id="ac0f84c2-ef80-4fdb-a3e0-574fb215450e"
              defaultMessage="Page Not Found"
            />
          }
          description={
            <FormattedMessage
              id="651702cf-4583-4c79-ac50-52451e6ccc16"
              defaultMessage="The page you're looking for doesn't exist or has been moved."
            />
          }
        >
            <Button
              onClick={handleGoHome}
              size={{ base: 'md', md: 'lg' }}
              w={{ base: 'full', sm: 'auto' }}
            >
              <FormattedMessage
                id="40c4f75f-5fb4-46de-abc6-245a987c51b9"
                defaultMessage="Go to Home"
              />
            </Button>
        </EmptyState>
      </AbsoluteCenter>
    </VStack>
  );
}
